import { Navigate, Routes, Route } from 'react-router-dom';
import { LoginPage } from './features/auth/login-page';
import { RegisterPage } from './features/auth/register-page';
import { PendingUsersPage } from './pages/pending-users-page';
import { ProtectedRoute } from './components/protected-route';
import { ProtectedLayout } from './components/protected-layout';
import { DashboardPage } from './pages/dashboard-page';
import { UnauthorizedPage } from './pages/unauthorized-page';
import { NotFoundPage } from './pages/not-found-page';
import { RoleCode } from '@app/shared';
import { SekolahPage } from './pages/master/sekolah-page';
import { JabatanPage } from './pages/master/jabatan-page';
import { PegawaiPage } from './pages/master/pegawai-page';
import { HonorPegawaiPage } from './pages/master/honor-pegawai-page';
import { HonorariumPage } from './pages/honorarium-page';
import { SlipHonorariumPage } from './pages/slip-honorarium-page';
import { SlipHonorariumDetailPage } from './pages/slip-honorarium-detail-page';
import { PengaturanPage } from './pages/pengaturan-page';
import { ProfilSayaPage } from './pages/profil-saya-page';
import { PeriodePage } from './pages/absensi/periode-page';
import { KalenderPage } from './pages/absensi/kalender-page';
import { AbsensiPage } from './pages/absensi/absensi-page';
import { LaporanAbsensiPage } from './pages/absensi/laporan-page';
import { AdminAkunPage } from './pages/admin-akun-page';
import { InstitutionSettingsPage } from './pages/institution-settings-page';
import { InsentifKegiatanPage } from './pages/master/insentif-kegiatan-page';
import { TotalJpMengajarPage } from './pages/total-jp-mengajar-page';
import { DraftHonorTotalJpPage } from './pages/draft-honor-total-jp-page';
import { AuditLogPage } from './pages/audit-log-page';
import { PegawaiRolePage } from './pages/pegawai-role-page';
import { SystemSettingsPage } from './pages/system-settings-page';
import { PermissionMatrixPage } from './pages/permission-matrix-page';
import { LaporanHonorariumPage } from './pages/laporan-honorarium-page';
import { JenisKomponenHonorPage } from './pages/master/jenis-komponen-honor-page';
import { KonfigurasiHonorJabatanPage } from './pages/master/konfigurasi-honor-jabatan-page';

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route element={<ProtectedLayout />}>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/unauthorized" element={<UnauthorizedPage />} />
        <Route
          path="/absensi"
          element={
            <ProtectedRoute
              requiredRoles={[RoleCode.ADMIN, RoleCode.GURU, RoleCode.KEPALA_SEKOLAH]}
            >
              <AbsensiPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/honorarium/slip/:pegawaiId"
          element={
            <ProtectedRoute requiredRoles={[RoleCode.ADMIN]}>
              <SlipHonorariumDetailPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/honorarium/slip"
          element={
            <ProtectedRoute requiredRoles={[RoleCode.ADMIN]}>
              <SlipHonorariumPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/honorarium/total-jp-mengajar"
          element={
            <ProtectedRoute requiredRoles={[RoleCode.ADMIN]}>
              <TotalJpMengajarPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/honorarium/periode/:periodeId/total-jp"
          element={
            <ProtectedRoute requiredRoles={[RoleCode.ADMIN]}>
              <DraftHonorTotalJpPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/honorarium/laporan"
          element={
            <ProtectedRoute requiredRoles={[RoleCode.ADMIN, RoleCode.KEPALA_SEKOLAH]}>
              <LaporanHonorariumPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/honorarium"
          element={
            <ProtectedRoute requiredRoles={[RoleCode.ADMIN]}>
              <HonorariumPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/master/pegawai/*"
          element={
            <ProtectedRoute requiredRoles={[RoleCode.ADMIN, RoleCode.KEPALA_SEKOLAH]}>
              <PegawaiPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/pengaturan"
          element={
            <ProtectedRoute requiredRoles={[RoleCode.ADMIN]}>
              <PengaturanPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings/institution"
          element={
            <ProtectedRoute requiredRoles={[RoleCode.ADMIN]}>
              <InstitutionSettingsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/master/insentif-kegiatan"
          element={
            <ProtectedRoute requiredRoles={[RoleCode.ADMIN]}>
              <InsentifKegiatanPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/master/sekolah"
          element={
            <ProtectedRoute requiredRoles={[RoleCode.ADMIN]}>
              <SekolahPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/master/jabatan"
          element={
            <ProtectedRoute requiredRoles={[RoleCode.ADMIN]}>
              <JabatanPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/master/honor-pegawai"
          element={
            <ProtectedRoute requiredRoles={[RoleCode.ADMIN]}>
              <HonorPegawaiPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/master/jenis-komponen-honor"
          element={
            <ProtectedRoute requiredRoles={[RoleCode.ADMIN]}>
              <JenisKomponenHonorPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/master/konfigurasi-honor-jabatan"
          element={
            <ProtectedRoute requiredRoles={[RoleCode.ADMIN]}>
              <KonfigurasiHonorJabatanPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/absensi/periode"
          element={
            <ProtectedRoute requiredRoles={[RoleCode.ADMIN]}>
              <PeriodePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/absensi/kalender"
          element={
            <ProtectedRoute requiredRoles={[RoleCode.ADMIN]}>
              <KalenderPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/absensi/laporan"
          element={
            <ProtectedRoute
              requiredRoles={[RoleCode.ADMIN, RoleCode.GURU, RoleCode.KEPALA_SEKOLAH]}
            >
              <LaporanAbsensiPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/akun"
          element={
            <ProtectedRoute requiredRoles={[RoleCode.ADMIN]}>
              <AdminAkunPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/pending-users"
          element={
            <ProtectedRoute requiredRoles={[RoleCode.ADMIN]}>
              <PendingUsersPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/audit-log"
          element={
            <ProtectedRoute requiredRoles={[RoleCode.ADMIN]}>
              <AuditLogPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/pegawai-roles"
          element={
            <ProtectedRoute requiredRoles={[RoleCode.ADMIN]}>
              <PegawaiRolePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/system-settings"
          element={
            <ProtectedRoute requiredRoles={[RoleCode.ADMIN]}>
              <SystemSettingsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/permissions"
          element={
            <ProtectedRoute requiredRoles={[RoleCode.ADMIN]}>
              <PermissionMatrixPage />
            </ProtectedRoute>
          }
        />
        <Route path="/profil-saya" element={<ProfilSayaPage />} />
        <Route path="/slip-saya" element={<ProfilSayaPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
